// extracted by mini-css-extract-plugin
export default {"tabs-container":"styles_tabs-container__BsgPs","overflow-container":"styles_overflow-container__uzxwc","tab":"styles_tab__h-T90","slider":"styles_slider__j7Xo8"};